import { EventEmitter } from '@angular/core';
var ExerciseFinishComponent = (function () {
    function ExerciseFinishComponent() {
        this.finishAnswer = new EventEmitter();
        this.assetsRoute = "../../../assets";
    }
    ExerciseFinishComponent.prototype.ngOnInit = function () {
    };
    ExerciseFinishComponent.prototype.ngAfterViewInit = function () {
    };
    ExerciseFinishComponent.prototype.goAnswer = function (tabNum) {
        this.finishAnswer.emit(tabNum);
    };
    return ExerciseFinishComponent;
}());
export { ExerciseFinishComponent };



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-finish/finish.component.ts.pre-build-optimizer.js